import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { formateDateTime } from '@utils/utils';

@Component({
  selector: 'wsb-sending-summary-modal',
  templateUrl: './sending-summary-modal.component.html',
  styleUrls: ['./sending-summary-modal.component.scss'],
  standalone: false
})
export class SendingSummuryModalComponent implements OnInit {
  @Input() messageType: string;
  @Input() quantity: number;
  @Input() message: string;
  @Input() recipientsNumber: number;
  @Input() sendingType: string;
  @Input() dateTime: string;
  @Input() sender: string;
  @Input() frequency: string;
  @Input() repeats: string;
  @Input() offsetControl: string;
  @Input() time: string;
  @Input() dynamicField: string;
  @Input() offset: string;
  @Input() senderBlocked: boolean;

  @Output() sendSMS: EventEmitter<any> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.dateTime) {
      this.dateTime = formateDateTime(this.dateTime.replace('+0000', ''));
    }
  }

  sendSms() {
    this.sendSMS.emit();
    this.activeModal.dismiss();
  }
}
